module.exports = __webpack_public_path__ + "static/media/barMachine.a0169e0f.png";